import { useState } from "react";
import { ChevronLeft, ChevronRight, Disc3, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { getRecordingTrack } from "../lib/api";

// previous / next track of the album found by a share link
export const AlbumNav = ({ linkInfo, onTrack }) => {
  const [busy, setBusy] = useState(false);
  const rec = linkInfo.recording;

  const go = async (n) => {
    setBusy(true);
    try {
      const data = await getRecordingTrack(rec.id, n);
      const title = data.results.map((r) => r.name).join(" / ") || data.recording.unknown?.join(" / ") || `Track ${n}`;
      onTrack(data.results, { ...linkInfo, title, recording: data.recording });
    } catch {
      toast.error("Could not load that track");
    } finally {
      setBusy(false);
    }
  };

  const Arrow = ({ n, dir, Icon }) => (
    <button
      onClick={() => go(n)}
      disabled={!n || busy}
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#e5e0d8] bg-white text-[#2d2824] transition-colors hover:bg-[#f3efea] disabled:opacity-30"
      aria-label={`${dir} track`}
      data-testid={`album-${dir}-track`}
    >
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="mb-4 flex items-center gap-3 rounded-2xl border border-[#e5e0d8] bg-white p-2" data-testid="album-nav">
      <Arrow n={rec.prev} dir="prev" Icon={ChevronLeft} />
      <div className="min-w-0 flex-1 text-center">
        <p className="truncate text-sm font-extrabold text-[#2d2824]" data-testid="album-nav-track">
          {busy ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : `Track ${rec.track} of ${rec.count}`}
        </p>
        <p className="flex items-center justify-center gap-1 truncate text-xs font-semibold text-[#6e655b]">
          <Disc3 className="h-3 w-3 shrink-0" />
          <span className="truncate">
            {rec.artist} · {rec.album}
          </span>
        </p>
      </div>
      <Arrow n={rec.next} dir="next" Icon={ChevronRight} />
    </div>
  );
};
